import React, { ReactNode } from "react";
import Popup from "reactjs-popup";
import 'reactjs-popup/dist/index.css';

import question from "../../question.svg";

function Explanation( props: React.PropsWithChildren ) {
	return (
		// ...
		<Popup
			trigger={
				<div className={"explanation"}>
					{/* eslint-disable-next-line jsx-a11y/alt-text */}
					<img src={question} alt={"Mehr Info"} />
				</div>
			}
			position={[ "top right" ]}
			closeOnDocumentClick
			arrowStyle={{ color: "#2a2e2d" }}
			children={((close: () => any) =>(<div className="popover-content" onClick={close}>{props.children}</div>) as any) as unknown as ReactNode}
		/>
		// ...
	);


}

export default Explanation;
